import { z } from "zod";

export const CreateProjectSchema = z.object({
  name: z.string().refine((v) => v.length > 0, {
    message: "Prosjektnavn må være lengere enn 0",
  }),
  users: z.array(z.string().uuid()),
});
